import React, { useState, useEffect, useRef } from 'react';
import { Button, Table, Spin, Input, Tabs, Modal } from 'antd';
import { CheckCircleOutlined, SearchOutlined, RedoOutlined, CloseCircleOutlined } from '@ant-design/icons';
import moment from 'moment';//日期格式化导包
import { Config } from '../../public/js/config';
import { Base } from '../../public/js/base';
import { ContextHandler } from '../../public/js/contextHandler';
import Message from '../../component/message/message';
import PropTypes from 'prop-types';//props传参检查库
import './selectUserModel.css';

const { TabPane } = Tabs;

const SelectUserModel = (props) => {

    const messageRef = useRef();
    const [isLoad, setIsLoad] = useState(false);
    const [spinInfo, setSpinInfo] = useState("");
    const [tabIndex, setTabIndex] = useState("1");
    const [searchModel, setSearchModel] = useState({});
    const [oldSearchModel, setOldSearchModel] = useState({});
    const [tables, setTables] = useState([]);
    const [tablesCount, setTablesCount] = useState(0);
    const [current, setCurrent] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [checkboxState, setCheckboxState] = useState([]);


    const [selectedStudentRowKeys, setSelectedStudentRowKeys] = useState([]);
    const [selectedStudent, setSelectedStudent] = useState([]);
    const [selectedAcademicRowKeys, setSelectedAcademicRowKeys] = useState([]);
    const [selectedAcademic, setSelectedAcademic] = useState([]);
    const [selectedIPRowKeys, setSelectedIPRowKeys] = useState([]);
    const [selectedIP, setSelectedIP] = useState([]);

    const [tablesIp, setTablesIp] = useState([]);
    const [tablesCountIp, setTablesCountIp] = useState(0);
    const [currentIp, setCurrentIp] = useState(1);
    const [pageSizeIp, setPageSizeIp] = useState(10);

    const [tablesAcademic, setTablesAcademic] = useState([]);
    const [tablesCountAcademic, setTablesCountAcademic] = useState(0);
    const [currentAcademic, setCurrentAcademic] = useState(1);
    const [pageSizeAcademic, setPageSizeAcademic] = useState(10);

    const selectedStudentList = props.selectedStudentList;
    const selectedAcademicList = props.selectedAcademicList;
    const selectedIpList = props.selectedIpList;
    const tableColumns = {
    }


    useEffect(() => {
        if(selectedStudentList!=null && selectedStudentList.length>0){
            const userIdListString =  selectedStudentList .map(item => item.userId)
            setSelectedStudentRowKeys(userIdListString)
            setSelectedStudent(selectedStudentList)
        }
        if(selectedAcademicList!=null && selectedAcademicList.length>0){
            const userIdListString =  selectedAcademicList .map(item => item.userId)
            setSelectedAcademicRowKeys(userIdListString)
            setSelectedAcademic(selectedAcademicList)
        }
        if(selectedIpList!=null && selectedIpList.length>0){
            const userIdListString =  selectedIpList .map(item => item.userId)
            setSelectedIPRowKeys(userIdListString)
            setSelectedIP(selectedIpList)
        }
        search(pageSize, 1, "N");
        searchStudent(pageSize, 1, "N");
        searchIP(pageSizeIp, 1, "N")
        searchAcademic(pageSizeAcademic, 1, "N")
    }, []);


    const searchChange = (key, value) => {
        messageShowHandler();
        setSearchModel(model => {
            return { ...model, ...{ [key]: value } };
        });
    }

    //查询学生
    const searchStudent = (pageSizeNew, current, flag, isShowMsg, newModel) => {
        if (Config.funcInfo.canSelect === "N") {
            return;
        }
        messageShowHandler();
        let model = {};
        if ("Y" === flag) {//翻頁
            model = oldSearchModel;
        } else {
            if (newModel) {
                model = JSON.parse(JSON.stringify({ ...searchModel, ...newModel }));
            } else {
                model = JSON.parse(JSON.stringify(searchModel));
            }
        }
        model.pageSize = pageSizeNew;
        model.startRow = (current - 1) * pageSizeNew;
        model.page = current;
        model.progCodeList = Config.userInfo?.progCodeList
        model.activeInd = 'Y'
        setIsLoad(true);
        setSpinInfo("Searching..." );
        Base.callBackApi("student/emailStudentList", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                if (!data.object.list && isShowMsg) {
                    errFrameShow("info", "No record is founed.");
                }
                if ("N" === flag) {
                    setOldSearchModel(JSON.parse(JSON.stringify(model)));
                }
                setTablesCount(data?.object?.total ?? 0);
                setTables(data?.object?.list ?? []);
                setCurrent(current);
                setPageSize(pageSizeNew);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    //查询公司
    const searchIP = (pageSizeNew, current, flag, isShowMsg, newModel) => {
        if (Config.funcInfo.canSelect === "N") {
            return;
        }
        messageShowHandler();
        let model = {};
        if ("Y" === flag) {//翻頁
            model = oldSearchModel;
        } else {
            if (newModel) {
                model = JSON.parse(JSON.stringify({ ...searchModel, ...newModel }));
            } else {
                model = JSON.parse(JSON.stringify(searchModel));
            }
        }
        model.pageSize = pageSizeNew;
        model.startRow = (current - 1) * pageSizeNew;
        model.page = current;
        model.progCodeList = Config.userInfo?.progCodeList
        model.activeInd = 'Y'
        setIsLoad(true);
        setSpinInfo("Searching..." );
        Base.callBackApi("partnerContact/searchEamilIp", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                if (!data.object.list && isShowMsg) {
                    errFrameShow("info", "No record is founed.");
                }
                if ("N" === flag) {
                    setOldSearchModel(JSON.parse(JSON.stringify(model)));
                }
                setTablesCountIp(data?.object?.total ?? 0);
                setTablesIp(data?.object?.list ?? []);
                setCurrentIp(current);
                setPageSizeIp(pageSizeNew);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    //查询学校
    const searchAcademic = (pageSizeNew, current, flag, isShowMsg, newModel) => {
        if (Config.funcInfo.canSelect === "N") {
            return;
        }
        messageShowHandler();
        let model = {};
        if ("Y" === flag) {//翻頁
            model = oldSearchModel;
        } else {
            if (newModel) {
                model = JSON.parse(JSON.stringify({ ...searchModel, ...newModel }));
            } else {
                model = JSON.parse(JSON.stringify(searchModel));
            }
        }
        model.pageSize = pageSizeNew;
        model.startRow = (current - 1) * pageSizeNew;
        model.page = current;
        model.progCodeList = Config.userInfo?.progCodeList
        model.activeInd = 'Y'
        setIsLoad(true);
        setSpinInfo("Searching..." );
        Base.callBackApi("academicStaff/searchEmailAcademic", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                if (!data.object.list && isShowMsg) {
                    errFrameShow("info", "No record is founed.");
                }
                if ("N" === flag) {
                    setOldSearchModel(JSON.parse(JSON.stringify(model)));
                }
                setTablesCountAcademic(data?.object?.total ?? 0);
                setTablesAcademic(data?.object?.list ?? []);
                setCurrentAcademic(current);
                setPageSizeAcademic(pageSizeNew);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const search = (pageSizeNew, currentPageNew, flag, isShowMsg) => {
        if (Config.funcInfo.canSelect === "N") {
            return;
        }
        messageShowHandler();  // 清除提示信息
        if(tabIndex == 1){
            searchStudent(pageSizeNew, currentPageNew, "N")
        }
    }

    const reset = () => {
        messageShowHandler();
        setSearchModel({});
        setOldSearchModel({});
        setTablesCount(0);
        setTables([]);
        setPageSize(10);
        setTablesAcademic([]);
        setTablesIp([]);
        setTablesCountAcademic(0);
        setTablesCountIp(0);
    }

    // Tab页切换
    const handleSelect = (key) => {
        messageShowHandler();
        clearSelect();
        if (key) {
            if (key === "3") {
                setSearchModel({});
                setOldSearchModel({});
                setTabIndex("3");
            } else if (key === "2") {
                setSearchModel({});
                setOldSearchModel({});
                setTabIndex("2");
            } else if (tabIndex !== "1") {
                setSearchModel({});
                setOldSearchModel({});
                setTabIndex("1");
                searchStudent(pageSize, current, "Y");
            }
        }
    }

    const handleTableChange = (pagination, filters, sorter) => {
        let orderBy = "";
        if (sorter.field) {
            if (sorter.order === "ascend") {
                orderBy = tableColumns[sorter.field];
            } else if (sorter.order === "descend") {
                orderBy = tableColumns[sorter.field] + " DESC";
            }
        }
        if (!!sorter.field || !!searchModel.orderBy) {
            if (orderBy !== searchModel.orderBy) {
                searchModel.orderBy = orderBy;
                search(pageSize, 1, "N", true);
            }
        }
    }


    //分页 页码切换变化查询
    const onChange = (currentNew, pageSizeNew) => {
        searchStudent(pageSizeNew, currentNew, "Y");
    }
    const onChangeAcademic = (currentNew, pageSizeNew) => {
        searchAcademic(pageSizeNew, currentNew, "Y");
    }
    const onChangeIp = (currentNew, pageSizeNew) => {
        searchIP(pageSizeNew, currentNew, "Y");
    }
    //分页 每页條數变化查询
    const onShowSizeChange = (currentNew, pageSizeNew) => {
        searchStudent(pageSizeNew, 1, "Y");
    }
    const onShowSizeChangeAcademic = (currentNew, pageSizeNew) => {
        searchAcademic(pageSizeNew, 1, "Y");
    }
    const onShowSizeChangeIp = (currentNew, pageSizeNew) => {
        searchIP(pageSizeNew, 1, "Y");
    }

    const errFrameShow = (style, msg) => {
        messageRef.current.setStyle(style)
        messageRef.current.setContent(msg)
        messageRef.current.setIsShow(true)
        document.documentElement.scrollTop = 0;
    }

    const messageShowHandler = () => {
        messageRef.current.setIsShow(false)
    }

    const onSelectChange = (selectedRowKeys, selectedRows) => {
        setSelectedRowKeys(selectedRowKeys);
        setCheckboxState(selectedRows);
    }

    const clearSelect = () => {
        setSelectedRowKeys([]);
        setCheckboxState([])
    }

    const columns = [
        {
            title: 'Student ID',
            dataIndex: 'studentAcctId',
            className: 'tableWidth11',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'studentAcctId') },
        },
        {
            title: "Student",
            dataIndex: 'firstName',
            className: 'tableWidth10',
            render: (text, record) => text + ' ' + record.lastName
        },
        {
            title: "Email",
            dataIndex: 'email',
            className: 'tableWidth10',
        },
        {
            title: 'Programme Name',
            dataIndex: 'progTitle',
            className: 'tableWidth16',
        },
        {
            title: 'Admission Year',
            dataIndex: 'studentEntryYear',
            className: 'tableWidth16',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'studentEntryYear') },
        },
        
        {
            title: 'Study Year Entry',
            dataIndex: 'studyYearEntry',
            className: "tableWidth16",
        },
        {
            title: 'Status',
            dataIndex: 'activeInd',
            className: 'tableWidth8',
            render: (text) => ContextHandler.getMapValueTransalation('activeTransalation', text)
        },
        {
            title: 'Inactive Date',
            dataIndex: 'inactiveDate',
            className: 'tableWidth14',
            render: text => text ? moment(text).format(Config.dateFormat5) : '',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'inactiveDate') },
        },
    ];

    const columnsTwo = [
        {
            title: 'Company Name',
            dataIndex: 'companyName',
            className: 'tableWidth24',
        },
        {
            title: "Contact ID",
            dataIndex: 'partnerContactAcctId',
            className: 'tableWidth14',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'partnerContactAcctId') },
        },
        {
            title: "Contact Title",
            dataIndex: 'contactTitle',
            className: 'tableWidth12',
        },
        {
            title: 'Contact Name',
            dataIndex: 'contactName',
            className: 'tableWidth15',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'contactName') },
        },
        {
            title: "Contact Email",
            dataIndex: 'contactEmail',
            className: 'tableWidth15',
        },
        {
            title: "Status",
            dataIndex: 'activeInd',
            className: 'tableWidth8',
            render: (text) => ContextHandler.getMapValue('activeMap', text)
        },
        {
            title: "Inactive Date",
            dataIndex: 'inactiveDate',
            className: 'tableWidth14',
            render: text => text ? moment(text).format(Config.dateFormat5) : '',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'inactiveDate') },
        },
    ];

    const columnsThree = [
        {
            title: 'Academic ID',
            dataIndex: 'academicStaffAcctId',
            className: 'tableWidth17',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'academicStaffAcctId') },
        },
        {
            title: 'Academic Name',
            dataIndex: 'staffName',
            className: 'tableWidth22',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'staffName') },
            render: (text, record) => record.firstName + ' ' + record.lastName
        },
        {
            title: "Staff Saluation",
            dataIndex: 'staffSaluation',
            className: 'tableWidth16',
        },
        {
            title: "Email",
            dataIndex: 'email',
            className: 'tableWidth16',
        },
        {
            title: "Status",
            dataIndex: 'activeInd',
            className: 'tableWidth12',
            render: (text) => ContextHandler.getMapValue('activeMap', text)
        },
        {
            title: "Inactive Date",
            dataIndex: 'inactiveDate',
            className: 'tableWidth14',
            render: (text) => text != null ? moment(text).format(Config.dateFormat5) : null
        },
    ];

    const rowSelection = {
        selectedRowKeys: selectedRowKeys,
        onChange: onSelectChange,
    };

    function getIntersection(collection1, collection2) {
        const result = [];
        for (const item1 of collection1) {
          for (const item2 of collection2) {
            if (item1 == item2.userId) {
              result.push(item2);
              break;
            }
          }
        }
        return result;
    }
    function mergeCollections(collection1, collection2) {
        const result = [...collection1];
        for (const item of collection2) {
          if (!result.some(obj => obj.userId === item.userId)) {
            result.push(item);
          }
        }
        return result;
    }

    const onSelectStudentChange = (selectedRowKeys, selectedRows) => {
        const listnoUndefinded = selectedRows.filter(item => item !== undefined);
        const list1 = getIntersection(selectedRowKeys,selectedStudentList);
        const list2 = getIntersection(selectedRowKeys,listnoUndefinded);
        const list3 = mergeCollections(list1,list2)
        setSelectedStudentRowKeys(selectedRowKeys);
        setSelectedStudent(list3);
    }

    const rowStudentSelection = {
        selectedRowKeys: selectedStudentRowKeys,
        onChange: onSelectStudentChange,
        preserveSelectedRowKeys: true,
    };

    const onSelectIPChange = (selectedRowKeys, selectedRows) => {
        const listnoUndefinded = selectedRows.filter(item => item !== undefined);
        const list1 = getIntersection(selectedRowKeys,selectedIpList);
        const list2 = getIntersection(selectedRowKeys,listnoUndefinded);
        const list3 = mergeCollections(list1,list2)
        setSelectedIPRowKeys(selectedRowKeys);
        setSelectedIP(list3);
    }

    const rowIPSelection = {
        selectedRowKeys: selectedIPRowKeys,
        onChange: onSelectIPChange,
        preserveSelectedRowKeys: true,
    };

    const onSelectAcademicChange = (selectedRowKeys, selectedRows) => {
        const listnoUndefinded = selectedRows.filter(item => item !== undefined);
        const list1 = getIntersection(selectedRowKeys,selectedAcademicList);
        const list2 = getIntersection(selectedRowKeys,listnoUndefinded);
        const list3 = mergeCollections(list1,list2)
        setSelectedAcademicRowKeys(selectedRowKeys);
        setSelectedAcademic(list3);
    }

    const rowAcademicSelection = {
        selectedRowKeys: selectedAcademicRowKeys,
        onChange: onSelectAcademicChange,
        preserveSelectedRowKeys: true,
    };

    const save = () => {
        if (selectedStudent.length == 0 && selectedAcademic.length ==0  && selectedIP.length ==0) {
            errFrameShow("error", "Please select a reord.");
            return;
        }
        props.onClose(true, selectedStudent,selectedAcademic,selectedIP);
    }

    return (
        <Modal
            visible={true}
            title="Select User"//标题
            centered//垂直居中
            closable//是否显示右上角的关闭按钮
            maskClosable={false}//点击蒙层是否允许关闭    
            width={'1170px'}
            onCancel={() => props.onClose(false)}
            footer={[
                <Button key='save' className='sysBtn btnBlue' type="primary" onClick={save} icon={<CheckCircleOutlined />}>Select</Button>,
                <Button key='cancel' className="sysBtn" onClick={() => props.onClose(false)} icon={<CloseCircleOutlined />}>Cancel</Button>
            ]}
        >
            {/* 提示信息弹框 */}
            <Message ref={messageRef} />
                <Spin spinning={isLoad} size="large" tip={spinInfo}>
                    {/* 审核彈框 */}
                    <Tabs activeKey={tabIndex} onChange={(e) => handleSelect(e)}>
                        <TabPane key="1" tab="Student">
                            <div className='sysRow'>
                                <div className='sysCol'>
                                    <div className="sysTitle">Student ID</div>
                                    <div className="sysSerchInput">
                                        <Input type="text" placeholder="Student ID" value={searchModel.studentAcctId}
                                            onChange={(e) => searchChange('studentAcctId', e.target.value)}
                                            onKeyDown={(e) => e.key === "Enter" ? search(pageSize, 1, "N", true) : null} />
                                    </div>
                                </div>

                                <div className='sysCol'>
                                    <div className="sysTitle">Student Name</div>
                                    <div className="sysSerchInput">
                                        <Input type="text" placeholder="Student Name" value={searchModel.studentName}
                                            onChange={(e) => searchChange('studentName', e.target.value)}
                                            onKeyDown={(e) => e.key === "Enter" ? search(pageSize, 1, "N", true) : null} />
                                    </div>
                                </div>
                                
                                <div className='sysSearchButton'>
                                    <Button className="sysBtn btnBlue" type="primary" onClick={() => search(pageSize, 1, "N", true)} hidden={Config.funcInfo.canSelect === "N"} icon={<SearchOutlined />}>Search</Button>
                                    <Button className="sysBtn" onClick={reset} icon={<RedoOutlined />}>Reset</Button>
                                </div>
                            </div>
                            <div className="sysLineEight"></div>
                            <div className="sysTable" id="tableOne">
                                <Table
                                    rowSelection={rowStudentSelection} //选择
                                    rowKey="userId"
                                    scroll={{ x: 1000 }}
                                    columns={columns} //列名
                                    dataSource={tables} //数据
                                    pagination={{  //分页
                                        showSizeChanger: true,                          //是否显示可以设置几条一页的选项
                                        onChange: onChange,            //上页下页或者跳页方法
                                        onShowSizeChange: onShowSizeChange,    //每页显示多少条数据方法
                                        total: tablesCount,             //总共多少条数据
                                        current: current,         //当前页
                                        pageSize: pageSize,       //每页显示多少条数据
                                        defaultCurrent: 1,                               //默认当前页为1
                                        size: "small"
                                    }}
                                />
                            </div>
                        </TabPane>
                        <TabPane tab={"Industry Partner"} key="2" forceRender={true}>
                        <div className='sysRow'>
                                <div className='sysCol'>
                                    <div className="sysTitle">Company Name</div>
                                    <div className="sysSerchInput">
                                        <Input type="text" placeholder="Company Name" value={searchModel.companyName}
                                            onChange={(e) => searchChange('companyName', e.target.value)}
                                            onKeyDown={(e) => e.key === "Enter" ? search(pageSize, 1, "N", true) : null} />
                                    </div>
                                </div>
                                <div className='sysCol'>
                                    <div className="sysTitle">Contact ID</div>
                                    <div className="sysSerchInput">
                                        <Input type="text" placeholder="Contact ID" value={searchModel.partnerContactAcctId}
                                            onChange={(e) => searchChange('partnerContactAcctId', e.target.value)}
                                            onKeyDown={(e) => e.key === "Enter" ? search(pageSize, 1, "N", true) : null} />
                                    </div>
                                </div>
                                <div className='sysCol'>
                                    <div className="sysTitle">Contact Name</div>
                                    <div className="sysSerchInput">
                                        <Input type="text" placeholder="Contact Name" value={searchModel.contactName}
                                            onChange={(e) => searchChange('contactName', e.target.value)}
                                            onKeyDown={(e) => e.key === "Enter" ? search(pageSize, 1, "N", true) : null} />
                                    </div>
                                </div>
                                <div className='sysSearchButton'>
                                    <Button className="sysBtn btnBlue" type="primary" onClick={() => searchIP(pageSizeIp, 1, "N")} hidden={Config.funcInfo.canSelect === "N"} icon={<SearchOutlined />}>Search</Button>
                                    <Button className="sysBtn" onClick={reset} icon={<RedoOutlined />}>Reset</Button>
                                </div>
                            </div>
                            <div className="sysLineEight"></div>
                            <div className="sysTable" id="tableOne">
                                <Table
                                    rowSelection={rowIPSelection} //选择
                                    rowKey="userId"
                                    scroll={{ x: 1100 }}
                                    columns={columnsTwo} //列名
                                    dataSource={tablesIp} //数据
                                    pagination={{  //分页
                                        showSizeChanger: true,                          //是否显示可以设置几条一页的选项
                                        onChange: onChangeIp,            //上页下页或者跳页方法
                                        onShowSizeChange: onShowSizeChangeIp,    //每页显示多少条数据方法
                                        total: tablesCountIp,             //总共多少条数据
                                        current: currentIp,         //当前页
                                        pageSize: pageSizeIp,       //每页显示多少条数据
                                        defaultCurrent: 1,                               //默认当前页为1
                                        size: "small"
                                    }}
                                />
                            </div>
                        </TabPane>
                        <TabPane tab={"Academic"} key="3" >
                            <div className='sysRow'>
                                <div className='sysCol'>
                                    <div className="sysTitle">Academic ID</div>
                                    <div className="sysSerchInput">
                                        <Input type="text" value={searchModel.academicStaffAcctId || ''}
                                            placeholder="Academic ID"
                                            onKeyDown={(e) => e.key === "Enter" ? search(pageSize, 1, "N", true) : null}
                                            onChange={(e) => searchChange('academicStaffAcctId', e.target.value)} />
                                    </div>
                                </div>
                                <div className='sysCol'>
                                    <div className="sysTitle">Academic Name</div>
                                    <div className="sysSerchInput">
                                        <Input type="text" placeholder="Academic Name" value={searchModel.staffName}
                                            onChange={(e) => searchChange('staffName', e.target.value)}
                                            onKeyDown={(e) => e.key === "Enter" ? search(pageSize, 1, "N", true) : null} />
                                    </div>
                                </div>
                                
                                <div className='sysSearchButton'>
                                    <Button className="sysBtn btnBlue" type="primary" onClick={() => searchAcademic(pageSizeAcademic, 1, "N", true)} hidden={Config.funcInfo.canSelect === "N"} icon={<SearchOutlined />}>Search</Button>
                                    <Button className="sysBtn" onClick={reset} icon={<RedoOutlined />}>Reset</Button>
                                </div>
                            </div>
                            <div className="sysLineEight"></div>
                            <div className="sysTable" id="tableOne">
                                <Table
                                    rowSelection={rowAcademicSelection} //选择
                                    rowKey="userId"
                                    scroll={{ x: 1000 }}
                                    columns={columnsThree} //列名
                                    dataSource={tablesAcademic} //数据
                                    pagination={{  //分页
                                        showSizeChanger: true,         //是否显示可以设置几条一页的选项
                                        onChange: onChangeAcademic,            //上页下页或者跳页方法
                                        onShowSizeChange: onShowSizeChangeAcademic,    //每页显示多少条数据方法
                                        total: tablesCountAcademic,             //总共多少条数据
                                        current: currentAcademic,         //当前页
                                        pageSize: pageSizeAcademic,       //每页显示多少条数据
                                        defaultCurrent: 1,        //默认当前页为1
                                        size: "small"
                                    }}
                                />
                            </div>
                        </TabPane>
                    </Tabs>
                </Spin>
        </Modal>
    )

}


SelectUserModel.propTypes = {
    onClose: PropTypes.func.isRequired,
    selectedStudentList: PropTypes.object.selectedStudentList,
    selectedAcademicList: PropTypes.object.selectedAcademicList,
    selectedIpList: PropTypes.object.selectedIpList,
}

export default SelectUserModel;